import React from 'react';
import BaseValidator from 'services/validations/base-validator';
import Const from 'constants';

class MaxHittersInLineupValidator extends BaseValidator {
    protected runValidation(): void {
        // @ts-ignore
        const {legacyControlledHitterStacking, sportConfig} = this.dependencies;

        if (!legacyControlledHitterStacking.isDoubleStackModeEnabled()) {
            return;
        }

        const hittersInLineupQuantity = sportConfig.getConfigProp('hittersInLineup');
        const firstGroupPlayersQuantity = legacyControlledHitterStacking.getFirstGroupPlayersQuantity();
        const secondGroupPlayersQuantity = legacyControlledHitterStacking.getSecondGroupPlayersQuantity();
        const stackingPlayersQuantity = firstGroupPlayersQuantity + secondGroupPlayersQuantity;

        if (hittersInLineupQuantity < stackingPlayersQuantity) {
            this.addError(`Amount of hitters exceeds ${hittersInLineupQuantity}, please decrease.`);
        }
    }
}

export default MaxHittersInLineupValidator;
